import { Link } from 'react-router-dom';

export default function CustomLink({ to, children, linkProps = {}, divProps = {} }) {
  return (
    <Link to={to} style={{textDecoration: 'none'}} {...linkProps}>
      <div style={{ textDecoration: 'none', color: 'inherit' }} {...divProps}>{children}</div>
    </Link>
  );
};